<template>
  <div :id="id"></div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
export default {
  props:{
    id:String
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      var chart = am4core.create(this.id, am4charts.PieChart);
      chart.innerRadius = am4core.percent(90);

      var pieSeries = chart.series.push(new am4charts.PieSeries());
      var label = chart.seriesContainer.createChild(am4core.Label);
      label.text = `xpto`;
      label.horizontalCenter = "middle";
      label.verticalCenter = "middle";
      label.fontSize = 14;
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "category";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.innerRadius = 2;
      pieSeries.slices.template.propertyFields.fill = "fill";
      pieSeries.labels.template.propertyFields.disabled = "labelDisabled";
      pieSeries.ticks.template.propertyFields.disabled = "labelDisabled";

      pieSeries.data = [
        {
          category: "xpto",
          value: 2,
          labelDisabled: true,
        },
        {
          category: "vazio",
          value: 10,
          labelDisabled: true,
          fill: "#dedede",
        },
      ];

      pieSeries.slices.template.states.getKey(
        "hover"
      ).properties.shiftRadius = 0;
      pieSeries.slices.template.states.getKey("hover").properties.scale = 1;
    },
  },
};
</script>